<template>
    <div class="bg-white pa-4 rounded-lg h-100 overflow-y-auto">
        <v-col xl="5" lg="7" md="8" sm="10" cols="12">
            <p class="text-primary font-weight-bold">مدیریت برچسب ها</p>
            <p class="text-meta mt-2 text-grey-darken-1">برچسب ها در هلپیکال ابزاری برای اضافه کردن جزئیات بیشتر به تیکت‌ها و دریافت گزارشات آماری از عملکرد سامانه می‌باشند.</p>
            <p class="text-small mt-1 text-grey">برچسب های مورد نظر خود را در کادر زیر تایپ کرده و سپس دکمه Enter را بفشارید.</p>
            <tag-input class="mt-4"></tag-input>
        </v-col>
    </div>
</template>


<script>
export default {
    title: "مدیریت برچسب‌ها",
    validate(context) {
        return context.rbac.can("manage tags");
    },
};
</script>
